import { jsx as r } from "react/jsx-runtime";
import { I as e } from "../icon-DNHpBTHs.mjs";
const t = {
  name: "arrow-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 12a.9.9 0 0 1 .264-.636l5.5-5.5a.9.9 0 0 1 1.272 1.272L6.173 11.1H20a.9.9 0 0 1 0 1.8H6.173l3.963 3.964a.9.9 0 1 1-1.272 1.272l-5.5-5.5A.9.9 0 0 1 3.1 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-left"],
  category: "utility"
}, l = (o) => /* @__PURE__ */ r(e, { ...o, svg: t });
l.displayName = "IconArrowLeft";
export {
  l as IconArrowLeft
};
//# sourceMappingURL=arrow-left.es.js.map
